/**
 * @generated SignedSource<<224dd7296749fb08f06124eb21f0b217>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderStatusType = "ClosedByAdmin" | "HasBillingDetails" | "HasCart" | "HasPaymentDetails" | "PaymentInProcess" | "PaymentReceived" | "Purchased" | "PurchasedAwaitingAccount" | "Transient";
export type orderEditScreen_OrderQuery$variables = {
  id: string;
  skip: boolean;
};
export type orderEditScreen_OrderQuery$data = {
  readonly node?: {
    readonly customerDetails?: {
      readonly " $fragmentSpreads": FragmentRefs<"billingDetailsForm_Billing_CustomerDetailsFragment">;
    } | null;
    readonly guestCustomerIds?: {
      readonly invoicingCustomerId: string | null;
      readonly stripeCustomerId: string | null;
    } | null;
    readonly id?: string;
    readonly purchaser?: {
      readonly accountId: string;
      readonly userId: string;
    } | null;
    readonly startedAsGuest?: boolean | null;
    readonly status?: OrderStatusType;
    readonly " $fragmentSpreads": FragmentRefs<"cartForm_OrderFragment" | "closeOrderAction_OrderFragment" | "eraseAttributionAction_OrderFragment" | "invoiceDataForm_OrderFragment" | "invoiceEmailActions_OrderFragment" | "paymentDataForm_OrderFragment">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"orderHistoryTable_OrderHistoriesFragment">;
};
export type orderEditScreen_OrderQuery = {
  response: orderEditScreen_OrderQuery$data;
  variables: orderEditScreen_OrderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Purchaser",
  "kind": "LinkedField",
  "name": "purchaser",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedAsGuest",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "GuestCustomerIds",
  "kind": "LinkedField",
  "name": "guestCustomerIds",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stripeCustomerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoicingCustomerId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceNumber",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  (v2/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentToInvoiceEmail",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentByUserId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "sentBy",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "houseNumber",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "street",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyDetails",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "orderEditScreen_OrderQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Billing_CustomerDetails",
                    "kind": "LinkedField",
                    "name": "customerDetails",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "billingDetailsForm_Billing_CustomerDetailsFragment"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "cartForm_OrderFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "paymentDataForm_OrderFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "invoiceDataForm_OrderFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "invoiceEmailActions_OrderFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "closeOrderAction_OrderFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "eraseAttributionAction_OrderFragment"
                  }
                ],
                "type": "Order",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "orderHistoryTable_OrderHistoriesFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "orderEditScreen_OrderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrderHistory",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "event",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isHistoryEvent"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "when",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ],
                        "type": "InvoiceSentEvent",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "previousInvoiceEmail",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "newInvoiceEmail",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "correctedByUserId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "correctedBy",
                            "plural": false,
                            "selections": (v11/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "InvoiceEmailCorrectedEvent",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/)
                        ],
                        "type": "ClaimEmailResentEvent",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/)
                        ],
                        "type": "InvoiceResentEvent",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "reason",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "closedByUserId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "closedBy",
                            "plural": false,
                            "selections": (v11/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "OrderClosedByAdminEvent",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Order",
            "abstractKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Billing_CustomerDetails",
                    "kind": "LinkedField",
                    "name": "customerDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "dateOfBirth",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Billing_InvoiceAddress",
                                "kind": "LinkedField",
                                "name": "invoiceAddress",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "companyName",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Billing_PrivateCustomerDetails",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v22/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "company",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "companyType",
                                "storageKey": null
                              }
                            ],
                            "type": "Billing_BusinessCustomerDetails",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "invoiceEmail",
                        "storageKey": null
                      },
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "salutation",
                        "storageKey": null
                      },
                      (v17/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v19/*: any*/),
                      (v21/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Cart",
                    "kind": "LinkedField",
                    "name": "cart",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Selection",
                        "kind": "LinkedField",
                        "name": "selection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SelectedProduct",
                            "kind": "LinkedField",
                            "name": "selectedProducts",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "amount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "product",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "selectedDiscountCodes",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AllowedPaymentMethods",
                    "kind": "LinkedField",
                    "name": "allowedPaymentMethods",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "paymentMethods",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "selectedPaymentMethod",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "paymentMethodType",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "invoiceData",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "File",
                            "kind": "LinkedField",
                            "name": "invoiceFile",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "CreatedInvoiceData",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Order",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "11a61cdc939040dea2c7a740567d7a77",
    "id": null,
    "metadata": {},
    "name": "orderEditScreen_OrderQuery",
    "operationKind": "query",
    "text": "query orderEditScreen_OrderQuery(\n  $id: ID!\n  $skip: Boolean!\n) {\n  node(id: $id) @skip(if: $skip) {\n    __typename\n    ... on Order {\n      id\n      status\n      purchaser {\n        accountId\n        userId\n      }\n      startedAsGuest\n      guestCustomerIds {\n        stripeCustomerId\n        invoicingCustomerId\n      }\n      customerDetails {\n        ...billingDetailsForm_Billing_CustomerDetailsFragment\n      }\n      ...cartForm_OrderFragment\n      ...paymentDataForm_OrderFragment\n      ...invoiceDataForm_OrderFragment\n      ...invoiceEmailActions_OrderFragment\n      ...closeOrderAction_OrderFragment\n      ...eraseAttributionAction_OrderFragment\n    }\n    id\n  }\n  ...orderHistoryTable_OrderHistoriesFragment\n}\n\nfragment billingDetailsForm_Billing_CustomerDetailsFragment on Billing_CustomerDetails {\n  data {\n    __typename\n    kind\n  }\n  ...privateBillingDetailsForm_Billing_CustomerDetailsFragment\n  ...businessBillingDetailsForm_Billing_CustomerDetailsFragment\n}\n\nfragment businessBillingDetailsForm_Billing_CustomerDetailsFragment on Billing_CustomerDetails {\n  firstName\n  lastName\n  street\n  houseNumber\n  postalCode\n  city\n  country\n  salutation\n  invoiceEmail\n  data {\n    __typename\n    ... on Billing_BusinessCustomerDetails {\n      companyDetails\n      company\n      companyType\n    }\n  }\n}\n\nfragment cartForm_OrderFragment on Order {\n  cart {\n    selection {\n      selectedProducts {\n        amount\n        product {\n          id\n          title\n        }\n      }\n      selectedDiscountCodes\n    }\n  }\n}\n\nfragment closeOrderAction_OrderFragment on Order {\n  id\n  status\n}\n\nfragment eraseAttributionAction_OrderFragment on Order {\n  id\n  purchaser {\n    userId\n  }\n}\n\nfragment invoiceDataForm_OrderFragment on Order {\n  invoiceData {\n    __typename\n    ... on CreatedInvoiceData {\n      invoiceNumber\n      invoiceId\n      invoiceFile {\n        url\n        id\n      }\n    }\n  }\n}\n\nfragment invoiceEmailActions_OrderFragment on Order {\n  id\n  status\n  customerDetails {\n    invoiceEmail\n  }\n  invoiceData {\n    __typename\n    ... on CreatedInvoiceData {\n      invoiceNumber\n    }\n  }\n}\n\nfragment orderHistoryEvent_OrderHistoryFragment on HistoryEvent {\n  __isHistoryEvent: __typename\n  kind\n  when\n  ... on InvoiceSentEvent {\n    invoiceId\n    invoiceNumber\n  }\n  ... on InvoiceEmailCorrectedEvent {\n    previousInvoiceEmail\n    newInvoiceEmail\n    correctedByUserId\n    correctedBy {\n      name\n      email\n      id\n    }\n  }\n  ... on ClaimEmailResentEvent {\n    sentToInvoiceEmail\n    sentByUserId\n    sentBy {\n      name\n      email\n      id\n    }\n  }\n  ... on InvoiceResentEvent {\n    invoiceNumber\n    sentToInvoiceEmail\n    sentByUserId\n    sentBy {\n      name\n      email\n      id\n    }\n  }\n  ... on OrderClosedByAdminEvent {\n    reason\n    closedByUserId\n    closedBy {\n      name\n      email\n      id\n    }\n  }\n}\n\nfragment orderHistoryTable_OrderHistoriesFragment on Query {\n  node(id: $id) {\n    __typename\n    ... on Order {\n      history {\n        ...orderHistoryTable_OrderHistoryFragment\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment orderHistoryTable_OrderHistoryFragment on OrderHistory {\n  id\n  createdAt\n  status\n  event {\n    __typename\n    kind\n    ...orderHistoryEvent_OrderHistoryFragment\n  }\n}\n\nfragment paymentDataForm_OrderFragment on Order {\n  allowedPaymentMethods {\n    paymentMethods\n  }\n  selectedPaymentMethod {\n    __typename\n    kind\n    paymentMethodType\n  }\n}\n\nfragment privateBillingDetailsForm_Billing_CustomerDetailsFragment on Billing_CustomerDetails {\n  invoiceEmail\n  houseNumber\n  salutation\n  postalCode\n  firstName\n  lastName\n  country\n  street\n  city\n  data {\n    __typename\n    ... on Billing_PrivateCustomerDetails {\n      dateOfBirth\n      invoiceAddress {\n        firstName\n        lastName\n        postalCode\n        city\n        country\n        houseNumber\n        street\n        companyDetails\n        companyName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7462dbd32321a0fc6c234b3e61572f0d";

export default node;
